<template>
  <v-container
    class="mb-12 mt-6"
  >
    <v-row
      align="center"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          business
        </v-icon>
        <h2 class="display-2 my-2">
          Willkommen in Deinem Büro
        </h2>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="space-around"
      class="text-center mb-1"
    >
      <v-col
        cols="12"
        md="10"
      >
        <div v-if="this.$store.state.init">
          <v-stepper v-model="e1" class="mt-4">
            <v-stepper-header>
              <v-stepper-step
                :complete="e1 > 1"
                step="1"
              >
                Willkommen {{ username }}
              </v-stepper-step>
              <v-divider />
              <v-stepper-step
                :complete="e1 > 2"
                step="2"
              >
                Team/Verein erstellen
              </v-stepper-step>
              <v-divider />
              <v-stepper-step
                step="3"
              >
                Sponsor wählen
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-content step="1">
              <v-card class="grey lighten-3 pa-6 mb-2">
                <p class="title">
                  Dein erster Tag im Büro.
                </p>
                <p>Bevor Du loslegen kannst, müssen wir Dein Managerprofil erstellen.</p>
                <p>
                  Suche Dir ein Managerbild aus, dass zu Dir passt und gib Dir einen Nutzernamen.<br> Dieser Name wird ggf. nach außen Sichtbar sein und für das Chat- / Nachrichtensystem verwendet
                </p>
                <v-row
                  class="mt-6"
                >
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="username"
                      :rules="managerNameRules"
                      :error-messages="errorMessageManagerName"
                      prepend-icon="mdi-account"
                      type="text"
                      name="username"
                      label="Dein Managername"
                      required
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="text-center"
                  >
                    <v-row
                      justify="center"
                      align="center"
                      no-gutters
                    >
                      <v-col class="text-right">
                        <v-btn
                          outlined
                          fab
                          small
                          color="primary"
                          top
                          class="mr-2"
                          @click="changeManagerImage(-1)"
                        >
                          <v-icon>mdi-arrow-left-bold</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col>
                        <img :src="managerImageSrc" class="elevation-2">
                      </v-col>
                      <v-col class="text-left">
                        <v-btn
                          outlined
                          fab
                          small
                          color="primary"
                          top
                          class="ml-2"
                          @click="changeManagerImage(1)"
                        >
                          <v-icon>mdi-arrow-right-bold</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <p>Managerbild aussuchen.</p>
                  </v-col>
                </v-row>
              </v-card>
              <v-btn
                :loading="$store.state.loading"
                :disabled="$store.state.loading"
                color="primary"
                @click="saveStep1()"
              >
                Weiter zu Schritt 2 <v-icon right dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card class="grey lighten-3 pa-6 mb-2">
                <p class="title">
                  Step 2
                </p>
                <div v-if="!teamNameAndLogoSaved">
                  <p>
                    Nachdem wir die Formalitäten zu Deiner Person geklärt haben, wird es Zeit Dein Team/Verein zu erstellen. <br>
                    Gib deinem Team/Verein einen Namen und wenn Du willst, lade ein Team-/Vereinslogo hoch.<br>
                    (Der Team/Vereinsname und das Logo, können ggf. nach außen sichtbar sein. Verletzte also keine Rechte.)
                  </p>
                  <p>Wähle dann noch die Wurfzahl aus, die Dein Team absolvieren soll.</p>
                </div>
                <v-row
                  v-if="!teamNameAndLogoSaved"
                  class="mt-6"
                >
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      :rules="managerTeamRules"
                      :error-messages="errorMessageManagerTeam"
                      v-model="teamname"
                      prepend-icon="mdi-account"
                      type="text"
                      name="teamname"
                      label="Dein Teamname"
                      required
                    />
                    <p>Vereinslogo hochladen (oder freilassen)</p>
                    <v-file-input
                      :rules="imageRules"
                      id="teamimagefile"
                      accept="image/png, image/jpeg"
                      show-size
                      label="Team-Logo"
                      placeholder="Neues Logo suchen..."
                      prepend-icon="mdi-camera"
                      @change="onFileChange"
                      v-model="teamLogoFile"
                    />
                    <v-btn
                      v-show="teamimage !== ''"
                      @click="deleteTeamImage()"
                    >
                      Bild löschen <v-icon right dark>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="text-center"
                    style="vertical-align:middle;"
                  >
                    <p class="title">
                      Logo-Vorschau:
                    </p>
                    <v-avatar
                      size="62"
                      class="grey lighten-4"
                    >
                      <v-img :src="teamimage" />
                    </v-avatar>
                    <br>
                    {{ teamname }}
                  </v-col>
                  <br>
                  <v-col
                    cols="12"
                    class="mt-4"
                  >
                    <v-card flat class="grey lighten-4">
                      <v-card-text>
                        <v-row
                          justify="space-around"
                        >
                          <v-col
                            cols="12"
                          >
                            <h3 class="title black--text">
                              Wurfzahl wählen
                            </h3>
                          </v-col>
                          <v-radio-group v-model="wurfzahl" class="ma-0">
                            <v-radio
                              :value="120"
                              label="120 Wurf"
                            />
                            <v-radio
                              :value="200"
                              label="200 Wurf"
                            />
                          </v-radio-group>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <br>
                    <v-btn
                      :loading="$store.state.loading"
                      :disabled="$store.state.loading"
                      color="primary"
                      @click="saveTeamname()"
                    >
                      Teamname und Logo speichern.
                      <v-icon
                        right
                        dark
                      >
                        mdi-arrow-right
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row v-if="teamNameAndLogoSaved">
                  <v-col
                    cols="12"
                  >
                    <h4 class="title">
                      Der Zufallsgenerator hat Dir diese Spieler erstellt:
                    </h4>
                    <p>(Gespielt wird in gemischten Mannschaften.)</p>
                    <v-row
                      justify="center"
                    >
                      <v-col
                        cols="12"
                        sm="10"
                      >
                        <players-table
                          :players="$store.state.teamStore.players"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-btn
                  v-if="spielerErstellt"
                  :loading="$store.state.loading"
                  :disabled="$store.state.loading"
                  color="primary"
                  @click="gotoe3()"
                >
                  Weiter zu Schritt 3 <v-icon right dark>
                    mdi-arrow-right
                  </v-icon>
                </v-btn>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card class="grey lighten-3 pa-6 mb-12">
                <p class="title">
                  Step 3
                </p>
                <p>
                  Deine Spieler wollen bezahlt werden, wähle einen Sponsor aus.<br>
                  (<b>Hinweis:</b> Je besser Deine Spieler werden, desto mehr Gehalt verlangen Sie pro Spieltag.)
                </p>
                <p class="font-weight-bold">
                  Aktuelle Gehaltsausgaben für Deine Spieler: {{ $store.getters['teamStore/getSallary'] | currency }}
                </p>

                <sponsoren-list
                  ref="sponsorauswahl"
                  :sponsoren="$store.state.moneyStore.sponsoren"
                />
              </v-card>
              <v-btn
                :loading="$store.state.loading"
                :disabled="$store.state.loading"
                color="primary"
                @click="finishInit()"
              >
                Gewählten Sponsor speichern <v-icon right dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
            </v-stepper-content>
          </v-stepper>
        </div>

        <div v-else>
          <v-row
            align="center"
            justify="space-around"
            class="text-center my-4"
          >
            <v-col
              cols="12"
              sm="4"
            >
              <v-avatar
                size="82px"
                class="grey lighten-4 ma-2"
              >
                <v-img :src="$store.state.managerStore.managerImages[$store.state.managerStore.imageId]" alt="Manager-Bild" />
              </v-avatar>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <h3 class="headline font-weight">
                Hallo
                <span class="font-weight-black">{{ username }}</span>,
              </h3>
              <h3 class="headline">
                Du bist Manager und Trainer von
                <span class="font-weight-black">{{ $store.state.teamStore.team.name }}</span>!
              </h3>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-avatar
                size="82px"
                class="grey lighten-4 ma-2"
              >
                <v-img :src="$store.state.teamStore.team.logo" />
              </v-avatar>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mt-2 text-center">
              <p class="subtitle-1">
                In Deinem Büro erhälst Du einen Überblick zu allen wichtigen Details Deines Teams.<br>In der linken Navigation kannst Du dein Team managen und trainieren.
              </p>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="space-around"
            class="text-center my-6"
          >
            <v-col
              cols="12"
              sm="10"
              class="mb-6 mx-auto text-left"
            >
              <v-card dark color="amber darken-4" class="orange-background">
                <v-card-title>
                  <h4 class="headline">
                    aktuelle Saison <small>- Nr: {{ $store.state.saisonStore.saison.nr }}</small><br>
                    {{ $store.state.saisonStore.saison.name }} - Spieltag {{ $store.state.saisonStore.saison.spieltag }}
                  </h4>
                </v-card-title>
                <v-divider />
                <v-card-text class="white black--text">
                  <table>
                    <tr>
                      <td class="pr-6">
                        Spieler im Kader:
                      </td><td>{{ $store.state.office.players }}</td>
                    </tr>
                    <tr><td>Rekorde:</td><td> {{ $store.state.office.heimRekord }} (H) /  {{ $store.state.office.auswRekord }} (A)</td></tr>
                    <tr><td>Tabellenposition:</td><td>Platz {{ $store.state.office.tablePos }} in der {{ $store.state.teamStore.team.liga }} / {{ $store.state.teamStore.team.wurfzahl }} Wurf</td></tr>
                    <tr><td>letztes Spiel:</td><td> {{ $store.state.office.lastGame }} </td></tr>
                    <tr
                      v-if="$store.state.office.nextGame.text !== ''"
                    >
                      <td>nächtes Spiel:</td><td>{{ $store.state.office.nextGame.text }}</td>
                    </tr>
                    <tr>
                      <td>Aufstellung:</td><td>{{ $store.state.teamStore.aufstellung | aufstellung }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-row
              align="center"
              justify="space-around"
              class="text-left my-6"
            >
              <v-col>
                <v-card dark color="amber darken-4" class="orange-background">
                  <v-card-title>
                    <h4 class="headline">
                      Ausrüstung
                    </h4>
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="white black--text">
                    <table>
                      <tr><td>Heimbahn:</td><td>{{ $store.state.kegelbahnStore.kegelbahn.name }} ({{ $store.state.kegelbahnStore.kegelbahn.zustand }}%) </td></tr>
                      <tr>
                        <td class="pr-6">
                          Fahrzeug:
                        </td><td>{{ $store.state.fahrzeugStore.fahrzeug.name }} ({{ $store.state.fahrzeugStore.fahrzeug.zustand }}%)</td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col>
                <v-card dark color="amber darken-4" class="orange-background">
                  <v-card-title>
                    <h4 class="headline">
                      Finanzen
                    </h4>
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="white black--text">
                    <table>
                      <tr>
                        <td class="pr-6">
                          Girokonto:
                        </td><td>{{ $store.state.moneyStore.giro | currency }}</td>
                      </tr>
                      <tr><td>Sponsoren:</td><td>{{ $store.state.moneyStore.sponsor.spieltag | currency }} pro Spieltag</td></tr>
                    </table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-col
              cols="12"
              sm="10"
              class="mx-auto my-6"
            >
              <v-card dark class="orange-background">
                <v-card-title primary-title dark>
                  <h3 class="headline mx-auto">
                    Mannschaftswerte durch Deine Aufstellung
                  </h3>
                </v-card-title>
                <v-divider />
                <v-row
                  align="center"
                  justify="space-around"
                  class="pa-6 white black--text"
                >
                  <v-col
                    cols="6"
                    class="text-center mb-6"
                  >
                    <h4 class="subtitle-1">
                      Heim-Index
                    </h4>
                    <v-progress-circular
                      :value="$store.state.office.heimIndex"
                      :color="$store.state.office.heimIndex | getStatusColor"
                      size="48"
                    >
                      <b>{{ $store.state.office.heimIndex }}</b>
                    </v-progress-circular>
                    <h5 class="body-2 mt-1">
                      ∅ {{ $store.state.office.avgheimIndex }} /  max: {{ $store.state.office.maxheimIndex }}
                    </h5>
                  </v-col>

                  <v-col
                    cols="6"
                    class="text-center mb-6"
                  >
                    <h4 class="subtitle-1">
                      Ausw.-Index
                    </h4>
                    <v-progress-circular
                      :value="$store.state.office.auswIndex"
                      :color="$store.state.office.auswIndex | getStatusColor"
                      size="48"
                    >
                      <b>{{ $store.state.office.auswIndex }}</b>
                    </v-progress-circular>
                    <h5 class="body-2 mt-1">
                      ∅ {{ $store.state.office.avgauswIndex }} /  max: {{ $store.state.office.maxauswIndex }}
                    </h5>
                  </v-col>

                  <v-col
                    xs3
                    class="text-center mb-2"
                  >
                    <h4 class="subtitle-1">
                      ∅<br>Kraft<br>
                      <v-icon
                        :color="$store.state.office.kraft | getStatusColor"
                      >
                        mdi-dumbbell
                      </v-icon>
                    </h4>
                    <v-progress-circular
                      :value="$store.state.office.kraft"
                      :color="$store.state.office.kraft | getStatusColor"
                      size="48"
                    >
                      <b>{{ $store.state.office.kraft }}</b>
                    </v-progress-circular>
                  </v-col>

                  <v-col
                    xs3
                    class="text-center mb-2"
                  >
                    <h4 class="subtitle-1">
                      ∅<br>Motivation<br>
                      <v-icon
                        :color="$store.state.office.motivation | getStatusColor"
                      >
                        mdi-brain
                      </v-icon>
                    </h4>
                    <v-progress-circular
                      :value="$store.state.office.motivation"
                      :color="$store.state.office.motivation | getStatusColor"
                      size="48"
                    >
                      <b>{{ $store.state.office.motivation }}</b>
                    </v-progress-circular>
                  </v-col>

                  <v-col
                    xs3
                    class="text-center mb-2"
                  >
                    <h4 class="subtitle-1">
                      ∅<br>Technik<br>
                      <v-icon
                        :color="$store.state.office.technik | getStatusColor"
                      >
                        mdi-webcam
                      </v-icon>
                    </h4>
                    <v-progress-circular
                      :value="$store.state.office.technik"
                      :color="$store.state.office.technik | getStatusColor"
                      size="48"
                    >
                      <b>{{ $store.state.office.technik }}</b>
                    </v-progress-circular>
                  </v-col>

                  <v-col
                    xs3
                    class="text-center mb-2"
                  >
                    <h4 class="subtitle-1">
                      ∅<br>Kondition<br>
                      <v-icon
                        :color="$store.state.office.kondition | getStatusColor"
                      >
                        mdi-heart-pulse
                      </v-icon>
                    </h4>
                    <v-progress-circular
                      :value="$store.state.office.kondition"
                      :color="$store.state.office.kondition | getStatusColor"
                      size="48"
                    >
                      <b>{{ $store.state.office.kondition }}</b>
                    </v-progress-circular>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="space-around"
            class="text-left my-6"
          >
            <v-col
              cols="12"
            >
              <h4 class="text-center headline my-6 font-weight-black">
                Ereignisse
              </h4>
              <v-timeline>
                <v-timeline-item
                  v-for="(item,i) in $store.state.office.ereignisse"
                  :key="i"
                  small
                >
                  <template v-slot:opposite>
                    <span
                      :class="`headline font-weight-bold ${item.color}--text`"
                      v-html="`${item.saison.name} <br> Spieltag: ${item.saison.spieltag}`"
                    />
                  </template>
                  <v-card class="elevation-2">
                    <v-card-title class="headline" v-html="item.title" />
                    <div class="caption">
                      <v-icon small class="ml-4">
                        mdi-calendar-clock
                      </v-icon>
                      <span class="ml-1">{{ item.datum }}</span>
                    </div>
                    <v-card-text>
                      <div class="subtitle-2" v-html="item.text" />
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { ROOT_SET_SNACKBAR, CHAT_RESET_NEW_MESSAGE_COUNTER, CHAT_SEND_MESSAGE } from '../store/mutation-types'
import { ROOT_SET_SNACKBAR } from '../store/mutation-types'
export default {
  name: 'Office',
  metaInfo: {
    title: 'Büro'
  },
  data: function () {
    return {
      e1: 0,
      username: '',
      managerNameRules: [],
      errorMessageManagerName: [],
      managerImageSrc: '/static/game/manager/manager-1.png',
      imageIndex: 0,
      teamname: '',
      managerTeamRules: [],
      errorMessageManagerTeam: [],
      imageRules: [
        value => !value || value.size < 2097152 || 'Das Logo darf nicht größer als 2 MB sein!'
      ],
      teamimage: '',
      showTeamImage: false,
      teamLogoFile: null,
      fileType: '.jpg',
      wurfzahl: 120,
      teamNameAndLogoSaved: false,
      spielerErstellt: false,
      chattext: 'Hallo :-)'
    }
  },
  filters: {
    aufstellung: function (value) {
      if (value.length < 6) return 'Achtung! Für das nächste Spiel fehlen noch Spieler in Deiner Aufstellung'
      return 'Du hast genug Spieler aufgestellt.'
    }
  },
  watch: {
    username: function (value) {
      let name = value
      if (name === '' || typeof name === 'undefined') {
        name = ''
      } else {
        name = name.replace(/[^a-zA-Z0-9_\-öäüÖÄÜßẞ ]/g, '')
      }
      if (name.length > 32) {
        name = name.substring(0, 32)
      }
      this.$store.commit('managerStore/MANAGER_SET_NAME', name)
      this.username = name
    },
    teamname: function (value) {
      let name = value
      if (name === '' || typeof name === 'undefined') {
        name = ''
      } else {
        name = name.replace(/[^a-zA-Z0-9_\-öäüÖÄÜßẞ ]/g, '')
      }
      if (name.length > 32) {
        name = name.substring(0, 32)
      }
      this.$store.commit('teamStore/TEAM_SET_TEAM_NAME', name)
      this.teamname = name
    }
  },
  created: function () {
    // check if user is loged in, otherwhise redirect
    if (!this.$store.state.loggedIn) {
      this.$router.replace({ path: '/login' })
    }

    this.username = this.$store.state.managerStore.name
    this.e1 = this.$store.state.init.step
  },
  mounted: async function () {
    // let container = this.$el.querySelector('#chatBox')
    // container.scrollTop = container.scrollHeight
    // this.$store.commit(CHAT_RESET_NEW_MESSAGE_COUNTER)
    if (this.$store.state.init === false) {
      // load office data in background
      await this.$store.dispatch('getOfficeData')
      // logos laden und in den cache
      await this.$store.dispatch('saisonStore/loadAllLogos')
    }
  },
  methods: {
    // sendChatMessage: async function () {
    //   // default message settings
    //   let dMS = {
    //     chatText: '',
    //     chatRoom: 'chat'
    //   }

    //   if (this.chattext) {
    //     dMS.chatText = this.chattext
    //     this.chattext = ''
    //   }
    //   // if (options.chatRoom) {
    //   //   dMS.chatRoom = options.chatRoom
    //   // }
    //   if (dMS.chatText !== '' && dMS.chatText.length > 3) {
    //     this.$store.commit(CHAT_SEND_MESSAGE, dMS)
    //   } else {
    //     this.$store.commit(ROOT_SET_SNACKBAR, 'Chat-Text eingeben', { root: true })
    //   }
    //   this.$store.commit(CHAT_RESET_NEW_MESSAGE_COUNTER)

    //   let container = this.$el.querySelector('#chatBox')
    //   container.scrollTop = container.scrollHeight
    // },
    finishInit: async function () {
      // save sponsor
      if (await this.$store.dispatch('moneyStore/saveSponsor', this.$refs.sponsorauswahl.radioSelected)) {
        // set home screen and init chat
        // this.initChatsystem()
      }
    },
    gotoe3: async function () {
      // this.currentSallary = this.$store.getters['teamStore/getSallary']
      if (await this.$store.dispatch('moneyStore/getAllSponsoren')) {
        // goto tab 3
        this.e1 = 3
      }
    },
    saveTeamname: async function () {
      if (this.teamname.length === null || this.teamname.length < 3) {
        this.managerTeamRules = ['Teamname muss mindestens 3 Zeichen haben']
        this.errorMessageManagerTeam = ['Teamname muss mindestens 3 Zeichen haben']
      } else {
        // save send with axios
        if (await this.$store.dispatch('teamStore/saveTeamnameAndLogo', {
          teamname: this.teamname,
          image: this.teamimage,
          type: this.fileType,
          wurfzahl: this.wurfzahl
        })) {
          // show Players
          this.teamNameAndLogoSaved = true
          this.spielerErstellt = true
        }
      }
    },
    saveStep1: async function () {
      if (this.username.length === null || this.username.length < 3) {
        this.managerNameRules = ['Nutzername muss mindestens 3 Zeichen haben']
        this.errorMessageManagerName = ['Nutzername muss mindestens 3 Zeichen haben']
      } else {
        if (await this.$store.dispatch('managerStore/saveManagerNameAndImage', {
          username: this.username,
          image: this.imageIndex
        })) {
          // set new el
          this.e1 = 2
        }
      }
    },
    changeManagerImage: function (value) {
      const length = this.$store.state.managerStore.managerImages.length
      const newVal = this.imageIndex + value

      if (newVal <= 0) {
        this.imageIndex = 0
      } else if (newVal >= length) {
        this.imageIndex = length - 1
      } else {
        this.imageIndex = newVal
      }

      this.managerImageSrc = this.$store.state.managerStore.managerImages[this.imageIndex]
      this.$store.commit('managerStore/MANAGER_SET_IMAGE_ID', this.imageIndex)
    },
    onFileChange: function (File) {
      if (!File) {
        document.getElementById('teamimagefile').value = ''
        this.teamLogoFile = null
        this.teamimage = ''
        this.showTeamImage = false
        return false
      }

      const filesize = ((this.teamLogoFile.size / 1024) / 1024).toFixed(2) // MB
      if (filesize > 2) {
        // show error
        this.$store.commit(ROOT_SET_SNACKBAR, 'Datei darf nicht größer als 2 MB sein')
        document.getElementById('teamimagefile').value = ''
        this.teamimage = ''
        this.showTeamImage = false
        return false
      }

      const type = this.teamLogoFile.type
      if (type !== 'image/jpeg' && type !== 'image/jpg' && type !== 'image/png') {
        this.$store.commit(ROOT_SET_SNACKBAR, 'Nur JPEG oder PNG Bilder sind erlaubt.')
        return false
      }
      this.fileType = type
      this.createImage(this.teamLogoFile)
    },
    setImage: function (src) {
      this.teamimage = src
      this.showTeamImage = true
    },
    createImage: function (file) {
      const reader = new FileReader()
      const vm = this
      reader.onload = function (e) {
        vm.setImage(e.target.result)
      }
      reader.readAsDataURL(file)
    },
    deleteTeamImage: function () {
      this.teamimage = ''
      this.showTeamImage = false
      document.getElementById('teamimagefile').value = ''
    }
  }
}
</script>
<style scoped>
.maxHeightScroll {
  height: 150px;
  max-height: 350px;
  overflow-y: scroll;
  scroll-behavior: smooth;
}

.orange-background {
  background-color: #FF7F50 !important;
  background-image: -webkit-linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
  background-image: -moz-linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
  background-image: -o-linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
  background-image: linear-gradient(170deg, #FF7F50 0%, #F7CE68 100%) !important;
}

</style>
